import "./WhatFamiliesAndProfessionalsSay.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Testimonials from "./sections/Testimonials";
import Professionaltestimonials from "./sections/Professionaltestimonials";
import ContactInquiry from "./sections/ContactInquiry";
import Footer from "@/reusable_sections/Footer";
export default function WhatFamiliesAndProfessionalsSayPage() {
  return <div>
      <Header />
      <Hero />
      <Testimonials />
      <Professionaltestimonials />
      <ContactInquiry />
      <Footer />
    </div>;
}